import { Fragment, useState } from 'react';
import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { ModalResponse } from '../../enum/ModalResponse';
import { routes } from '../../routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export interface ModalMeterConsentRefusedProps extends ModalProps {}
export default function ModalMeterConsentRefused({
  isOpen,
  onClickAction,
}: ModalMeterConsentRefusedProps) {
  const { t } = useTranslation();
  const [modalResponse, setModalResponse] = useState<ModalResponse | undefined>();
  const navigate = useNavigate();

  const handleClickNo = () => {
    setModalResponse(ModalResponse.CANCEL);
    if (onClickAction) {
      onClickAction(ModalResponse.CANCEL);
    }
  };

  const handleClickYes = () => {
    setModalResponse(ModalResponse.OK);
    if (onClickAction) {
      onClickAction(ModalResponse.OK);
    }
  };

  const handleOnClose = (response: ModalResponse | undefined) => {
    if (response === ModalResponse.OK) {
      navigate(`${routes.OVERVIEW.path}${window.location.search}`);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      actions={
        <Fragment>
          <Button className="btn btn--secondary mr-4 modal__actions__first" onClick={handleClickNo}>
            {t('common.no')}
          </Button>
          <Button className="btn btn--primary" onClick={handleClickYes}>
            {t('common.yes')}
          </Button>
        </Fragment>
      }
      onClose={() => handleOnClose(modalResponse)}
    >
      <Fragment>
        <p className="modal__message">{t('modal.meter.consent.refused.message.one')}</p>
      </Fragment>
    </Modal>
  );
}
